import * as React from 'react';
import ProjectChildComment from 'src/entities/ProjectChildComment';
import * as moment from 'moment';

export interface Props {
  comment: ProjectChildComment;
  showInputComment: (respondingTo: string, show: boolean) => void;
}

class ProjectChildCommentCardComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {
    return (
      <section>
        <div className="row comment-card">
          <div className="col-xs-1 text-center">
          <span className="circle">
            {this.props.comment.authorName![0] + this.props.comment.authorName!.split(' ')[1][0] || ''}
          </span>
          </div>
          <div className="col-xs-11">
            <h5 className="deco-title">
              {this.props.comment.authorName!},<br/>
              <span className="f-w-100 f-s-12">
              {moment(this.props.comment.createdAt!).format('DD [de] MMMM [de] YYYY [a las] HH:mm [h]')}
            </span>
            </h5>
            <div className="from-rich-editor" dangerouslySetInnerHTML={{__html: this.props.comment.body}}/>
            <div className="gap-20"/>
            <div className="comments-actions">
              <a
                className="margin-r-30 pointer c-grey"
                onClick={() => this.props.showInputComment('@' + this.props.comment.authorName!, true)}
              >
                <span className="reply"/>
                Responder
              </a>
              {/*TODO*/}
              {/*<a className="pointer c-grey">
                <span className="share-comment"/>
                Compartir
              </a>*/}
            </div>
          </div>
        </div>
        <div className="gap-20"/>
      </section>
    );
  }

}

export default ProjectChildCommentCardComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/comments/ProjectChildCommentCard.component.tsx